import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'timeslot_kind_exception_guid': 'String!',
	'employee_guid': '[String]',
};

export default gql(`
	mutation timeslot_kind_exception_to_employees( ${ HelperGraphql.createFields( fields ) } ) {
	    timeslot_kind_exception_to_employees( ${ HelperGraphql.createVariables( fields ) } ) {
	        employees {
	            guid
	        }
	    }
	}
`);

